export default "__VITE_ASSET__CGt7nYvh__"